<template>
  <el-row>
    <el-dialog :title="$t('741')" :visible.sync="visible" append-to-body :close-on-click-modal="false" width="720px">
      <div class="select-content">
        <!-- 列表项 -->
        <div class="active-content">
          <!-- 搜索框 -->
          <div class="search">
            <el-input
              v-model="searchKeyword"
              @input="handlerChangeSearch"
              prefix-icon="el-icon-search"
              :placeholder="$t('742')"
              clearable
            ></el-input>
          </div>
          <div v-load="loading" :loading-text="$t('989')" class="list-wrap">
            <el-checkbox
              class="depart-list"
              v-if="searchResultList.length"
              v-model="selectAll"
              :indeterminate="isIndeterminate"
              @change="handlerAllSelect"
              >{{ $t('21') }}</el-checkbox
            >
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                v-for="(item, index) in searchResultList"
                :key="index"
                :label="item"
                class="depart-list"
                :disabled="item.is_selected === 2"
              >
                <p>
                  <img
                    class="user-photo"
                    style="vertical-align: middle"
                    :src="item.avatar_url || getAvatar(item.sex || 0)"
                  />
                  {{ item.staff_name }}
                </p>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 已选项 -->
        <div class="select-show">
          <!-- 控制栏 清空 已选 -->
          <div class="select-show-header">
            <p>{{ $t('179') }}（{{ checkList.length }}）</p>
          </div>
          <!-- 列表项 -->
          <div class="select-show-list">
            <transition-group name="slide-fade" tag="ul">
              <li v-for="(item, index) in checkList" :key="item.staff_id">
                <!-- 员工 -->
                <p>
                  <img
                    class="user-photo"
                    style="vertical-align: middle"
                    :src="item.avatar_url || getAvatar(item.sex || 0)"
                  />
                  {{ item.staff_name }}
                </p>
                <el-button
                  icon="el-icon-close"
                  class="my-button"
                  type="text"
                  @click="handlerDel(item, index)"
                ></el-button>
              </li>
            </transition-group>
          </div>
        </div>
      </div>
      <!-- 底部操作栏 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('66') }}</el-button>
        <el-button type="primary" plain @click="doSubmint" :loading="btnLoad">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { round_group_staff_info, round_group_add_staff } from 'api/Attendance'
import { getAvatar } from '@/util/util'

export default {
  data() {
    return {
      selectAll: false, // 是否全选
      // isIndeterminate: false,
      visible: false,
      btnLoad: false, // 提交loading
      getAvatar, // 名称生成
      searchKeyword: '', // 人员搜索
      loading: false,
      disabledPersons: [], // 禁选人员
      checkList: [], // 已选人员
      allPersons: [], // 全部列表
      resultCheckList: [], // 搜索结果选中项
      searchResultList: [], // 搜索结果列表
      form: {} // 回传数据
    }
  },
  computed: {
    isIndeterminate() {
      const state = this.handleData()
      return !state.isAll && state.isSome
    }
  },
  methods: {
    init(form) {
      this.visible = true
      this.form = form
      this.requestPersonAll(form)
    },
    // 获取所有数据
    requestPersonAll(form) {
      this.loading = true
      round_group_staff_info(form)
        .then(res => {
          // 全部人员
          this.allPersons = res.data.all
          // 默认选中项
          this.$nextTick(() => {
            this.handlerChangeSearch()
            this.handlerDefaultSelected()
          })
        })
        .finally(() => (this.loading = false))
    },
    // 默认选中项
    handlerDefaultSelected() {
      this.checkList = []
      this.searchResultList.forEach(item => {
        if (item.is_selected === 1) this.checkList.push(item)
      })
    },
    // 人员搜索
    handlerChangeSearch() {
      if (!this.searchKeyword) {
        this.searchResultList = this.allPersons
        return
      }
      this.searchResultList = []
      const name = this.allPersons.filter(item => item.staff_name.indexOf(this.searchKeyword) !== -1)
      const code = this.allPersons.filter(item => item.staff_code.indexOf(this.searchKeyword) !== -1)
      const mobile = this.allPersons.filter(item => item.mobile.indexOf(this.searchKeyword) !== -1)
      const list = [...new Set([...name, ...mobile, ...code])]

      this.searchResultList = list
    },
    // 所有数据列表全选
    handlerAllSelect(val) {
      const checkList = val ? [...new Set([...this.searchResultList, ...this.checkList])] : []
      const data = checkList.filter(item => item.is_selected !== 2)
      this.checkList = data
    },
    // 判断全选状态
    handleData() {
      const checkObj = {}
      this.checkList.forEach(item => {
        checkObj[item.staff_id] = item
      })
      const data = this.searchResultList.filter(item => item.is_selected !== 2)
      const state = data.every(item => checkObj[item.staff_id])
      const state1 = data.some(item => checkObj[item.staff_id])
      this.selectAll = state1
      return {
        isAll: state,
        isSome: state1
      }
    },
    // 删除
    handlerDel(item, index) {
      if (this.searchKeyword) {
        const ind = this.searchResultList.findIndex(i => i.staff_id === item.staff_id)
        this.searchResultList.splice(ind, 1)
        if (!this.searchResultList.length) this.searchResultList = this.allPersons
      }
      this.checkList.splice(index, 1)
    },
    doSubmint() {
      this.form.staff_ids = this.checkList.map(item => item.staff_id)
      this.btnLoad = true
      round_group_add_staff(this.form)
        .then(res => {
          this.$emit('update')
          this.visible = false
        })
        .finally(() => (this.btnLoad = false))
    }
  }
}
</script>

<style lang="scss" scoped>
$width: 680px;
$padding: 20px;
.select-content {
  .list-wrap {
    height: calc(100% - 60px);
    overflow: auto;
  }
  .depart-list {
    display: block;
    margin: 0;
    padding: 10px;
    box-sizing: border-box;
    &:hover {
      background-color: rgba(black, 0.1);
    }
  }
  display: flex;
  height: 400px;
  > div {
    flex: 1;
    height: 100%;
    overflow: auto;
    padding: 0;
  }
  .active-content {
    border-right: 1px solid #eeeeee;
    .search {
      margin-bottom: 15px;
    }
  }
  .select-show {
    &-list {
      overflow: auto;
      height: calc(100% - 53px);
    }
    li {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 10px 18px 10px 20px;
      &:hover {
        background-color: rgba(black, 0.1);
      }
      > p {
        flex: 1;
      }
      > .my-button {
        width: 22px;
      }
    }
    &-header {
      height: 37px;
      line-height: 37px;
      display: flex;
      padding: 0 24px 0 20px;
      margin-bottom: 10px;
      > p {
        flex: 1;
      }
    }
  }
}
</style>
